<template>
  <div class="card mt-3" header-bg-variant="white">
    <div class="card-body">
      <div class="row mb-2 ">
        <div class="col">
          <h5 data-test-hook="plan-cost-header-text" v-if="this.getV1Type() === v1WIFI">
            {{ $t('xFuelMonitorWifiFree') }}
          </h5>
          <h5 data-test-hook="plan-cost-header-text" v-else-if="this.getV1Type() === v1LTE">
            {{ $t('xFuelSupplierManaged') }}
          </h5>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col">
          <span data-test-hook="plan-cost-header-text">
            {{ $t('xPlanStatus') }}
          </span>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col">
          <strong data-test-hook="plan-cost" v-if="this.getV1Type() === v1WIFI">
            {{ $t('xActive') }}
          </strong>
          <strong data-test-hook="plan-cost" v-else-if="this.getV1Type() === v1LTE">
            {{ v1FuelMonitor.name }}&nbsp;{{ $t('xManagedByFuelSupplier') }}
          </strong>
        </div>
      </div>

      <div class="accordion" role="tablist" style="width:100%;">
        <div class="accordion-wrapper" style="border: 1px solid lightgrey; padding: 10px; border-radius: 10px;">
          <div v-b-toggle="'collapse-dealerManaged-' + v1FuelMonitor.apparatusId">
            <div class="row align-items-center no-gutters">
              <div class="col align-items-center">
                <i class="fa-regular fa-circle-info pr-2"></i><strong>{{ $t('xProductsAndFeatures') }}</strong>
              </div>
              <div class="col-auto">
                <i class="fas fa-chevron-down when-closed"></i>
                <i class="fas fa-chevron-up when-open"></i>
              </div>
            </div>
          </div>
          <b-collapse :id="'collapse-dealerManaged-' + v1FuelMonitor.apparatusId">
            <div class="row">
              <div class="col">
                <hr class="mx-0 px-0" />
              </div>
            </div>
            <div class="row mb-2">
              <div class="col">
                <p class="mb-0 pb-0">
                  <strong data-test-hook="products-included-text" v-if="this.getV1Type() === v1WIFI">
                    {{ $t('xProductsIncludedInPlan') }} {{ $t('xFuelMonitorWifiFree') }}
                  </strong>
                  <strong data-test-hook="products-included-text" v-else-if="this.getV1Type() === v1LTE">
                    {{ $t('xProductsIncludedInPlan') }} {{ $t('xFuelSupplierManaged') }}
                  </strong>
                </p>
              </div>
            </div>
            <i class="fa-kit fa-fw fa-tank"></i>&nbsp;&nbsp;{{ v1FuelMonitor.name }}
            <div class="row mt-3 mb-2">
              <div class="col">
                <p class="mb-0 pb-0">
                  <strong data-test-hook="features-included-text" v-if="this.getV1Type() === v1WIFI">
                    {{ $t('xFeaturesIncludedInPlan') }} {{ $t('xFuelMonitorWifiFree') }}
                  </strong>
                  <strong data-test-hook="features-included-text" v-else-if="this.getV1Type() === v1LTE">
                    {{ $t('xFeaturesIncludedInPlan') }} {{ $t('xFuelSupplierManaged') }}
                  </strong>
                </p>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col icon-and-text">
                <i class="fa-kit fa-fw fa-tank"></i>
                <span data-test-hook="features-included-list">
                  {{ $t('xSubFeaturesFmFuelLevelHistoryWarningsBattery') }}
                </span>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col icon-and-text">
                <i class="fal fa-check-circle"></i>
                <span data-test-hook="features-included-list">
                  {{ $t('xSubFeaturesFmMonitorOneFm') }}
                </span>
              </div>
            </div>
          </b-collapse>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as Constants from '@/constants'

/**Plan types and status had to be hard coded since Platform doesn't send that info */
export default {
  props: ['v1FuelMonitor'],
  computed: {
    v1WIFI() {
      return Constants.TankUtilityWifiDeviceType
    },
    v1LTE() {
      return Constants.TankUtilityLteDeviceTypeV1
    }
  },
  methods: {
    getV1Type() {
      const deviceType = this.v1FuelMonitor.properties?.find(x => x.type === Constants.ApparatusPropertyDevice)?.value
        ?.deviceType
      if (!deviceType) {
        return -1
      }
      return deviceType
    }
  }
}
</script>
